import React, { useState, useMemo, useCallback, useEffect } from "react";
import * as styles from "./Images.module.scss";
import vidIcon from "../../../../images/video-icon.png"; // Icono de video

// Transforma la URL de YouTube
const transformYouTubeUrl = (url) => {
  const videoId = url.split("v=")[1];
  return `https://www.youtube.com/embed/${videoId}?controls=0&rel=0`;
};

// Inserta el video en el orden correcto
const insertVideoInOrder = (images, video, videoOrder) => {
  const videoObject = { src: video.videoUrl, type: "video" };
  const imageObjects = images.map((img) => ({ src: img, type: "image" }));
  const adjustedOrder = videoOrder - 1;
  const combinedMedia = [];

  imageObjects.forEach((img, index) => {
    if (index === adjustedOrder) combinedMedia.push(videoObject);
    combinedMedia.push(img);
  });

  if (adjustedOrder >= imageObjects.length) combinedMedia.push(videoObject);

  return combinedMedia;
};

const Images = ({ images = [], videos = [], colorCategory }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const video = videos[0];
  const videoOrder = video ? video.order : -1;

  const media = useMemo(() => {
    return video ? insertVideoInOrder(images, video, videoOrder) : images.map((img) => ({ src: img.image, type: "image", alt: img.alt || "" }));
  }, [images, video, videoOrder]);
  console.log("media", media);

  const adjustedCurrentIndex = Math.min(currentIndex, media.length - 1);
  console.log("adjustedCurrentIndex", adjustedCurrentIndex);

  // Precarga de imágenes
  useEffect(() => {
    media.forEach((item) => {
      if (item.type === "image") {
        const img = new Image();
        img.src = item.src;
        img.alt = item.alt || "";
      }
    });
  }, [media]);

  // Cambiar imagen con las flechas
  const handleNextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % media.length);
  }, [media.length]);

  const handlePrevSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + media.length) % media.length);
  }, [media.length]);

  // Abrir la vista previa
  const openPreview = (index) => {
    setCurrentIndex(index);
    setIsPreviewOpen(true);
  };

  // Cerrar la vista previa
  const closePreview = () => {
    setIsPreviewOpen(false);
  };

  // Cerrar modal con tecla ESC
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") closePreview();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Swipe en móvil
  useEffect(() => {
    let touchStartX = 0;
    let touchEndX = 0;

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
      touchEndX = e.changedTouches[0].clientX;
      if (touchStartX - touchEndX > 50) handleNextSlide();
      if (touchEndX - touchStartX > 50) handlePrevSlide();
    };

    if (isPreviewOpen) {
      window.addEventListener("touchstart", handleTouchStart);
      window.addEventListener("touchend", handleTouchEnd);
    }

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [isPreviewOpen, handleNextSlide, handlePrevSlide]);

  return (
    <>
      <div className={styles.main__container}>
          {media[adjustedCurrentIndex]?.type === "video" ? (
            <div className={styles.video_container}>
              <iframe 
                className={styles.video} 
                height="100%" 
                width="100%" 
                src={transformYouTubeUrl(video?.videoUrl)} 
                title="YouTube video player" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerpolicy="strict-origin-when-cross-origin" 
                allowfullscreen
              ></iframe>
            </div>
          ) : (
            <img
              key={media[adjustedCurrentIndex]?.src}
              className={styles.main_img}
              src={media[adjustedCurrentIndex]?.src || ""}
              alt={media[adjustedCurrentIndex]?.alt || ""}
              onClick={() => openPreview(adjustedCurrentIndex)}
            />
        )}
        <div className={styles.slider}>
          <div className={styles.slide_container}>
            {media.slice(0, 6).map((mediaItem, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)} // Solo cambia la imagen sin abrir la preview
                className={styles.slide_container_img}
                style={index === adjustedCurrentIndex ? { border: `1px solid ${colorCategory}` } : {}}
              >
                {mediaItem.type === "video" ? (
                  <div className={styles.video_icon_container}>
                    <img src={vidIcon} alt="Video Icon" className={styles.video_icon} />
                  </div>
                ) : (
                  <img src={mediaItem.src} alt="Receta" width={64} className={styles.slide} />
                )}
              </button>
            ))}

            {media.length > 6 && (
              <button className={styles.more_images} onClick={() => openPreview(5)}>
                +{media.length - 5}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* MODAL DE VISTA PREVIA */}
      {isPreviewOpen && (
        <div className={styles.preview_overlay} onClick={closePreview}>
          <div className={styles.preview_container} onClick={(e) => e.stopPropagation()}>
            <button className={styles.prev_button} onClick={handlePrevSlide}>&#10094;</button>
            {media[currentIndex]?.type === "video" ? (
              <iframe
                className={styles.preview_video}
                src={transformYouTubeUrl(media[currentIndex]?.src)}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            ) : (
              <img className={styles.preview_img} src={media[currentIndex]?.src} alt="Vista previa" />
            )}
            <button className={styles.next_button} onClick={handleNextSlide}>&#10095;</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Images;
